"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WHATSAPP_AI_REPLY_GRACE_MS = void 0;
exports.getWhatsappConversationHandling = getWhatsappConversationHandling;
// The AI normally answers within seconds. Past this window an unanswered
// customer is shown as waiting for staff, so a disabled or silent AI never
// hides them behind an "AI is handling it" label. See ADR
// derive-whatsapp-inbox-handling-state-from-ownership.
exports.WHATSAPP_AI_REPLY_GRACE_MS = 2 * 60_000;
function toMs(value) {
    if (value === undefined)
        return undefined;
    const ms = value instanceof Date ? value.getTime() : typeof value === 'number' ? value : Date.parse(value);
    return Number.isNaN(ms) ? undefined : ms;
}
function getWhatsappConversationHandling(conversation, now = Date.now()) {
    if (conversation.optedOut)
        return 'opted_out';
    const lastInboundAt = toMs(conversation.lastInboundAt);
    const lastMessageAt = toMs(conversation.lastMessageAt);
    const awaitingReply = lastInboundAt !== undefined && (lastMessageAt === undefined || lastInboundAt >= lastMessageAt);
    if (awaitingReply) {
        return conversation.assistantPaused || now - lastInboundAt > exports.WHATSAPP_AI_REPLY_GRACE_MS ? 'needs_human' : 'ai_replying';
    }
    return conversation.assistantPaused ? 'human' : 'ai';
}
